import { mdiCheckAll, mdiClipboardEditOutline, mdiFile } from '@mdi/js';

const PLACEHOLDER = Object.freeze({
  REASON_FOR_SUSPICION:
    'Provide a summary to explain your suspicion and then provide a chronological sequence of events. Try to keep the content clear, concise and simple. For example, explain how you became aware of the situation, describe the events, activities and/or transactions that led you to be suspicious, and how and why you became suspicious because of these. “As a guide when submitting a Suspicious Activity Report (SAR), wherever you can, try to answer the following six basic questions to make the information provided as useful as possible:\n• Who?\n• What?\n• Where?\n• When?\n• Why?\n• How?\nRemember to include:\n• the date of activity\n• the type of product or service\n• how the activity will, or has, taken place when documenting the reason for suspicion.\nIf you are suspicious because the activity deviates from the normal activity for that individual/firm, briefly explain how the activity that gave rise to your suspicion differs from the normal.” TIP/REMINDER Have you clearly described the suspicion? This report will be read by a third party and potentially forms a basis of a report to Law Enforcement/Authorities. Have you clearly explained your concern so a third party can understand?',
});

const STATE_KEY = Object.freeze({
  DONE: 'DONE',
  DRAFT: 'DRAFT',
  TODO: 'TODO',
});

const ICONS = Object.freeze({
  [STATE_KEY.DONE]: mdiCheckAll,
  [STATE_KEY.DRAFT]: mdiFile,
  [STATE_KEY.TODO]: mdiClipboardEditOutline,
});

export default Object.freeze({
  ICONS,
  PLACEHOLDER,
  STATE_KEY,
});
